/**
 * abilityVfxFrostAura — Ashe Q Frost Shot / Ranger's Focus self-buff mesh (SP-01).
 */
export function buildFrostAura(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.5 * (spec.scale || 1);
  const ice = mat(THREE, spec.color, 0.85);
  const crystal = mat(THREE, 0xbae6fd, 0.9);

  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.45, s * 1.05, 24).rotateX(-Math.PI / 2),
    ice
  );
  ring.position.y = 0.08;
  group.add(ring);

  for (let i = 0; i < 5; i += 1) {
    const shard = new THREE.Mesh(new THREE.ConeGeometry(0.08 * s, 0.45 * s, 5), crystal);
    const a = (Math.PI * 2 / 5) * i;
    shard.position.set(Math.cos(a) * s * 0.7, 0.35 * s, Math.sin(a) * s * 0.7);
    group.add(shard);
  }

  const core = new THREE.Mesh(new THREE.SphereGeometry(s * 0.25, 8, 8), ice);
  core.position.y = 0.4;
  group.add(core);

  group.userData = { shape: 'frost_aura' };
  return group;
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
